export const core = {
  accountConfiguration: 'Configuración de cuenta',
  accountConfigurationUrl: 'dashboard',
  identityDetails: 'Detalles de identidad',
  identityDetailsUrl: 'identity-details',
  transactionHistory: 'Historial de transacciones',
  transactionHistoryUrl: 'transactions',
  withdraw: 'Retirar',
  withdrawUrl: 'withdrawals',
  myPromotions: 'Mis promociones',
  myPromotionsUrl: 'promotions',
  bonuses: 'Bonificaciones',
  bonusesUrl: 'bonuses',
  notifications: 'Notificaciones',
  notificationsUrl: 'notifications',
  logout: 'Cerrar sesión',
  verifyAccount: 'Verifica tu cuenta',
  completeProfile: 'Completar perfil',
  deposit: 'Depositar',
  myReferrals: 'Mis referidos',
  myReferralsUrl: 'referidos',

  verifyIdentity: 'Verificar identidad',
  verifiedProfile: 'Perfil verificado',
  statusApproved: 'Verificado',
  statusPending: 'Estado: Pendiente',
  statusRejected: 'Estado: Rechazado',
  statusInitial: 'Estado: No verificado',

  sendVerification: 'Enviar verificación',
  enterYourEmail: 'Ingrese su correo electrónico',
  resendVerification: 'Reenviar verificación',
  verified: 'Verificado',
  verifyEmail: 'Verificar email',
  update: 'Actualizar',
  completed: 'Completado',
  profileCompleted: 'Perfil completo',
  firstDepositCompleted: 'Primer depósito realizado',
  changeYourEmail: 'Cambia tu correo electronico',
  email: 'Correo',
  accountSettings: 'Configuración de cuenta',
  security: 'Seguridad',
  changePassword: 'Cambia tu contraseña',
  change: 'Cambiar contraseña',
  sending: 'Enviando...',
  validating: 'Validando...',
  processing: 'Procesando...',
  sendEmailPassRecover: 'Enviar correo de recuperación',
  sendOTPValidation: 'Validar código OTP',
  twoFactorAuthentication: 'Autenticación en dos pasos',
  advanced: 'Avanzado',
  deactivateAccount: 'Desactivar cuenta',
  firstDeposit: 'Primer deposito',
  shareProfile: 'Compartir perfil',
  cash: 'Efectivo',
  bank: 'Banco',
  wallet: 'Wallet',
  verifiedEmail: 'Correo verificado',

  dailyWithdrawalLimit: 'Límite de retiro diario',
  withdrawalCompleted: 'Retiro completado',
  withdrawalPending: 'Retiro aprobado',
  withdrawalRequested: 'Retiro solicitado',
};

export const errors = {
  emailVerificationSent: 'Error al enviar el correo',
  msgEmailVerificationSent: 'Correo no enviado, intentalo de nuevo',
  msgPassEmailVerificationSent: 'Correo no encontrado, verifica tu correo y intentalo de nuevo',
  emailChangeTryAgain: 'Error, al cambiar el correo, inténtelo nuevamente',
  tryAgain: 'Error, intenta de nuevo',
  phoneNumberNotFound: 'El número de teléfono no se encuentra registrado',
  passwordChangedUnsuccessfully: 'Error, al cambiar la contraseña, inténtalo de nuevo',
  otpCodeRequired: 'Código OTP requerido',
  otpCodeInvalid: 'Código OTP inválido. Debe contener exactamente 6 dígitos numéricos',
  otpCodeNotFound: 'No se encontró un código de verificación. Por favor, solicita uno nuevo',
  otpCodeExpired: 'El código ha expirado. Por favor, solicita uno nuevo',
  otpMaxAttemptsReached: 'Has alcanzado el máximo de intentos. Por favor, solicita un nuevo código',
  otpCodeInvalidRetry: 'Código inválido. Por favor, verifica e intenta nuevamente',
};

export const messages = {
  emailSentSuccessfully: 'Correo enviado exitosamente',
  emailVerificationSent: 'Correo de verificacion enviado correctamente, revisa tu bandeja de entrada',
  emailResetPasswordSent: 'Correo de reseteo de contraseña enviado correctamente, revisa tu bandeja de entrada',
  firstDeposit: 'Realice su primer depósito para comenzar a jugar y aprovechar nuestras ofertas y promociones.',
  identityVerification: 'Proporcione documentos de identificación para confirmar su identidad y acceder a todas las funciones de la cuenta.',
  completeProfileA: 'Complete su perfil proporcionando información adicional para una experiencia personalizada.',
  completeProfileB: 'Complete su perfil verificando su email para una experiencia personalizada.',

  accountSettingsA: 'Agrega más seguridad a tu cuenta de powerbet cuando inicias sesión con correo electrónico / contraseña.',
  accountSettingsGoogle: 'Si tu cuenta de powerbet fue creada con Google comunicate con soporte para hacer cambios en ella.',
  accountSettingsB: 'Agrega más seguridad a tu cuenta de powerbet cuando inicias sesión con correo electrónico / contraseña. Se enviará un código de verificación a tu correo electrónico cada vez que inicies sesión para proteger tu cuenta de forma segura.',
  accountSettingsC: 'Agrega más seguridad a tu cuenta de powerbet cuando inicias sesión con correo electrónico / contraseña. Se enviará un código de verificación a tu correo electrónico cada vez que inicies sesión para proteger tu cuenta de forma segura.',
  accountSettingsD: '¿Quiere desactivar temporalmente su cuenta? contact a nuestro equipo de soporte.',
  accountSettingsE: 'Si, desactiva mi cuenta',
  emailChangeRequest: 'Se ha enviado la solicitud de cambio de correo, revisa la bandeja de entrada',
  errorInvalidEmail: 'El correo electrónico es inválido',

  passwordEmailSentA: 'Correo de cambio de contraseña enviado',
  passwordEmailSentB: 'Por favor, revisa tu bandeja de entrada',
  passwordEmailNotSentA: 'Error al enviar el correo',
  passwordEmailNotSentB: 'No se pudo enviar el correo de cambio de contraseña, intentalo de nuevo',

  requestFailedA: 'Error al procesar la solicitud',
  requestFailedB: 'Por favor, inténtalo de nuevo más tarde',
  withEmail: 'Con email',
  withPhone: 'Con teléfono',
  enterYourEmail: 'Ingresa tu correo electrónico con el que te registraste para recuperar tu contraseña',
  enterOTPToValidateBankAccount: 'Ingresa el código OTP enviado a tu correo electrónico para autorizar la cuenta',
  enterYourMobilePhone: 'Ingresa el correo teléfonico con el que te registraste para recuperar tu contraseña',
  enterYourMobilePhoneCode: 'Ingresa el código de verificación enviado a tu teléfono para recuperar tu contraseña',
  validatePhoneNumber: 'Validar teléfono',
  validateOTP: 'Validar código',
  password: 'Contraseña',
  enterYourPassword: 'Ingresa tu contraseña',
  enterYourPasswordConfirm: 'Ingresa tu contraseña nuevamente',
  changePassword: 'Cambiar contraseña',
  passwordChangedSuccessfully: 'Contraseña cambiada correctamente',
  passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
  passwordRequiresUppercase: 'La contraseña debe contener al menos una letra mayúscula',
  passwordRequiresLowercase: 'La contraseña debe contener al menos una letra minúscula',
  passwordRequiresNumber: 'La contraseña debe contener al menos un número',
  passwordRequiresSpecialChar: 'La contraseña debe contener al menos un carácter especial',
  passwordInvalidCharacters: 'La contraseña contiene caracteres no permitidos. Solo se permiten letras, números y los caracteres especiales: !@#$%^&*(),.?":{}|<>',
  passwordsDoNotMatch: 'Las contraseñas no coinciden',
  defaultUserName: 'Usuario',
  otpCodeSentMessage: 'Código de verificación enviado a tu correo electrónico',
  otpCodeValidated: 'Código validado correctamente',
  passwordUpdatedSuccessfully: 'Contraseña actualizada exitosamente',
  passwordStrength: {
    title: 'Requisitos de contraseña',
    veryWeak: 'Muy débil',
    weak: 'Débil',
    fair: 'Regular',
    strong: 'Fuerte',
    criteria: {
      uppercase: 'Una letra mayúscula',
      lowercase: 'Una letra minúscula',
      number: 'Un número',
      specialChar: 'Un carácter especial',
      length: 'Al menos 8 caracteres',
    },
  },
};

export const settingsModalTexts = {
  title: 'Configuración de cuenta',
  description: 'Datos de tu cuenta, seguridad, dirección, notificaciones y autoexclusión',
  sections: {
    account: 'Cuenta',
    security: 'Seguridad',
    address: 'Dirección',
    notifications: 'Notificaciones',
    selfExclusion: 'Autoexclusión',
  },
  username: 'Nombre de usuario',
  firstName: 'Nombre',
  lastName: 'Apellido',
  phone: 'Número de teléfono',
  birthday: 'Cumpleaños',
  day: 'Día',
  month: 'Mes',
  year: 'Año',
  edit: 'Editar',
  demo: {
    username: 'rasetsu999',
    firstName: 'Vincent',
    lastName: 'Silverhand',
    phone: '+7 (777) 777 - 77 - 77',
    day: '1',
    month: '12',
    year: '2026',
  },
} as const
